var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contact-overlay" }, [
    _c(
      "div",
      { staticClass: "contact-overlay--content-wrapper grid grid__base" },
      [
        _c("overlay-close-btn", { attrs: { facets: ["small"] } }),
        _vm._v(" "),
        _c("div", { staticClass: "grid--container" }, [
          _c("div", { staticClass: "contact-overlay--row grid--row" }, [
            _c("div", { staticClass: "contact-overlay--col grid--col" }, [
              _vm.content
                ? _c(
                    "div",
                    { staticClass: "contact-overlay--content" },
                    [
                      _c("v-runtime-template", {
                        attrs: { template: _vm.content }
                      })
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "contact-overlay--loader-wrapper" },
                    [_c("dat-loader")],
                    1
                  )
            ])
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-92a57d7a", { render: render, staticRenderFns: staticRenderFns })
  }
}